import './product_note.css';
import { CommentIcon } from "../../assets/icons/CommentIcon";
import { useSingleProduct } from "../../context/SingleProductContext";

export const ProductNote = () => {
    //HOOKS
    const { comment, setComment } = useSingleProduct();

    return (
        <div className='product_modal_comment'>
            <div className='head'>
                <CommentIcon />
                <h2>
                    Comments
                </h2>
            </div>
            <div className='request_container'>
                <p>
                    Add a special request (Optional)
                </p>
                <textarea placeholder='Your comment here' value={comment} onChange={(e) => setComment(e.target.value)}></textarea>
            </div>
        </div>
    );
}
